import {
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
} from "@mui/material";
import { useTranslation } from "@refinedev/core";
import { useFormContext } from "react-hook-form";

const steps = ["addStore", "authorization", "notificationSettings"];

// Paints the active step connector line with primary color
const Connector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export const FormStepper = () => {
  const { translate } = useTranslation();
  const { getValues } = useFormContext();

  return (
    <Stepper
      activeStep={getValues("step")}
      alternativeLabel
      sx={{ marginBottom: "24px" }}
      connector={<Connector />}
    >
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>
            {translate("pages.stores.create.steps." + label)}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
